import React from 'react'
import { Box } from '@mui/material'

import { useSnackbarContext } from './snackbar.context.ts'
import { SnackItem } from './snack-item.tsx'

export const Snackbar = (): React.ReactElement => {
  const { snacks } = useSnackbarContext()

  return (
    <Box
      sx={(theme) => ({
        maxWidth: 600,
        position: 'fixed',
        top: 8,
        right: 8,
        zIndex: theme.zIndex.snackbar + 1,
      })}
    >
      {snacks.map((snack) => (
        <SnackItem key={snack.id} {...snack} />
      ))}
    </Box>
  )
}
